import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm, change as changeFieldValue } from "redux-form";
import { TextInput } from "../../../common/form";
import { FormattedMessage, intlShape } from "react-intl";

import validationUtils from "../../../../utils/ValidationUtils";
import { BLOC_VALIDATION_RULES } from "./blocValidationRules";

class BasicBlocFields extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field
          id="name"
          name="name"
          component={TextInput}
          required={true}
          maxLength={BLOC_VALIDATION_RULES.name.maxLength.value}
          label={<FormattedMessage id="admin.blocs.form.name" />}
        />
      </form>
    );
  }
}

BasicBlocFields.propTypes = {
  changeFieldValue: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  scene: PropTypes.string,
  validation: PropTypes.object,
  handleSubmit: PropTypes.func,
};

BasicBlocFields.defaultProps = {
  scene: "",
};

BasicBlocFields.contextTypes = {
  getData: PropTypes.func,
  intl: intlShape,
};

BasicBlocFields.childContextTypes = {
  scene: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
  };
}

export default connect(null, mapDispatchToProps, null, { withRef: true })(
  reduxForm({
    form: "bloc",
    validate: (values) =>
      validationUtils.validate(values, BLOC_VALIDATION_RULES),
  })(BasicBlocFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/BasicBlocFields.js